import { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { SpaceProps, LayoutProps, TypographyProps } from 'styled-system';
import { Container } from '../../components/layout';

interface StyleProps extends SpaceProps, LayoutProps, TypographyProps {}

export const OneItemGrid = styled(Container)<StyleProps>`
  width: 100%;
  max-width: 810px;
  margin: 0 auto;
  padding: 0;
`;

export const AcuityWrapper = styled.div`
  padding: 0px 24px 80px;
  overflow: hidden !important;
`;

export const OneColumnDiv = styled(Container)<StyleProps>`
  margin: 0;
  padding: 0;
`;

export const AcuityColumn = ({ children, testId }: PropsWithChildren<{ testId?: string }>) => (
  <AcuityWrapper data-testid={testId}>{children}</AcuityWrapper>
);
